// extracted by mini-css-extract-plugin
export var active = "Tab-module--active--49bc5";
export var icon = "Tab-module--icon--02851";
export var tab = "Tab-module--tab--a6034";
export var tabs = "Tab-module--tabs--5ba20";
export var tabsWrapper = "Tab-module--tabsWrapper--7e295";